export default __webpack_public_path__ + "static/media/Shirt5.d4b6bd4a.jpeg";